<template>
  <div id="popup_get_resume" :class="$store.state.tariff.style">
    <div class="popup_block">
      <div class="back_to_icon" @click="backPayment()"></div>
      <div class="close" @click="closeTariffModal()"></div>
      <div class="title_plane">{{$store.state.tariff.translations[0].name}}</div>
      <div class="about_plane">{{$store.state.tariff.translations[0].description}}</div>
      <div class="period_tariff">
        <div class="pricing">
          <div class="time">{{$store.state.tariff.translations[0].period_text}}</div>
          <div class="price">{{$store.state.tariff.price > 0 ? $store.state.tariff.price_by_lang_modal : 'FREE'}}
          </div>
        </div>
      </div>
      <div class="resume_tariff" data-v-step="3">
        <div
          v-for="(template, index) in $store.state.tariff.templates"
          :key="index">

          <a @click="redirectCreate(template)">
            <div class="img">
              <img :src="template.image">
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {};
    },
    methods: {
      closeTariffModal() {
        this.$store.commit("isOpenTariffModel", false);
      },
      redirectCreate(template) {
        this.$http({
          method: "get",
          url: `/api/cv/check-if-has-cv/${template.version}`,
        }).then(({data}) => {
          if (data.ifHasCv) {
            this.$store.commit('isOpenConfirmModal',{
              version:  template.version
            });
            this.$store.commit('isOpenTariffModel',false);
          }else {
            this.closeTariffModal();
            this.$router.push({
              name: "cv-create-" + template.version,
              params: {lang: this.$store.getters.locale}
            });
          }
        });
      },
      backPayment() {
        this.$store.commit("isOpenTariffModel", false);
        this.$store.commit("paymentModal", true);
      }
    },
    watch: {}
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/modals/Templates.vue